import { SEND_USER_DETAILS_FAILURE, SEND_USER_DETAILS_REQUEST, SEND_USER_DETAILS_SUCCESS } from '../../actions';
const initialState = {
    data: null,
    result: null,
    loading: false,
    error: null,
};
const userDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case SEND_USER_DETAILS_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, result: action.payload });
        case SEND_USER_DETAILS_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: false, data: action.payload, error: null });
        case SEND_USER_DETAILS_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        default:
            return state;
    }
};
export default userDetailsReducer;
